import { render, staticRenderFns } from "./password.vue?vue&type=template&id=63be550f&"
import script from "./password.js?vue&type=script&lang=js&"
export * from "./password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports